<template>
  <div class="document-wrapper">
    <div class="document-container">
      <div class="columns">
        <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRequiredInformation(information.id)"/>
        <div class="input-data">
          <b-input @change="handleUpdate" placeholder="Заголовок информации" v-model="information.title" />
          <b-input @change="handleUpdate" placeholder="Текст информации" type="textarea" v-model="information.text"/>
          <table class="dates" v-if="showDatesTable">
            <thead>
              <td>Дата раскрытия</td>
              <td>Период актуальности</td>
            </thead>
            <tbody>
              <td>
                <el-date-picker
                  v-model="disclosureDate"
                  type="date"
                  :editable="false"
                  @change="dateChanged"
                >
                </el-date-picker>
              </td>
              <td>
                <el-date-picker
                  v-model="startDate"
                  type="date"
                  :editable="false"
                  @change="dateChanged"
                >
                </el-date-picker>
                —
                <el-date-picker
                  v-model="endDate"
                  :editable="false"
                  type="date"
                  @change="dateChanged"
                >
                </el-date-picker>
              </td>
            </tbody>
          </table>
          <div class="button-group" v-if="category === 'none'">
            <a class="button is-info"
              @click="handleAddRequiredInformationDocument(information.id)"
              ><img src="/static/img/icons/document.svg"/> Добавить документ</a>
            <a class="button is-info" @click='addUrl'>
              <img src="/static/img/icons/link.svg"/>Добавить ссылку</a>
            <a class="button is-info" @click='handleAddRequiredInformationRow(information.id)'>
              <img src="/static/img/icons/table.svg"/>Добавить отчет о тех. сбоях</a>
              <a class="button is-info" @click='handleAddRequiredBookKeeping(information.id)'>
                <img src="/static/img/icons/table.svg"/>Добавить бух. отчет</a>
          </div>
          <div class="documents" v-if="category === 'files'">
            <BankRequirementFile v-for="file in information.requiredInformationFiles" :file="file" :key="file.id"/>
            <span class="button-wrapper add-new-document" @click="handleAddRequiredInformationDocument(information.id)">
              <a class="button is-info">+</a> Прикрепить документ
            </span>
          </div>
          <div class="information-url" v-if="category === 'url'">
            <b-field>
              <img src="/static/img/icons/delete.svg" class="delete-icon" @click="hideUrl"/>
              <b-input placeholder="ссылка на сторонний ресурс или внутренний раздел сайта" v-model="information.url"
              @change="handleUpdate"
              />
            </b-field>
          </div>
          <div class="rows" v-if="category === 'rows'">
            <table>
              <thead>
                <tr>
                  <td>Дата и время технического сбоя</td>
                  <td>Причина технического сбоя</td>
                  <td>Дата раскрытия информации о техническом сбое</td>
                  <td>Информация о возобновлении работоспособности</td>
                  <td>Дата раскрытия информации о возобновлении</td>
                  <td></td>
                </tr>
              </thead>
              <BankRequirementRow v-for="row in information.requiredInformationRows" :row="row" :key="row.id"/>
            </table>
            <span class="button-wrapper add-new-document" @click="handleAddRequiredInformationRow(information.id)">
              <a class="button is-info">+</a> Добавить строку в таблице
            </span>
          </div>
          <div class="rows" v-if="category === 'bookkeeping'">
            <table class="bookkeeping">
              <thead>
                <tr>
                  <td>Файл</td>
                  <td>Дата раскрытия</td>
                  <td>Период актуальности</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <BankRequirementBookkeeping v-for="row in information.requiredInformationBookkeepings" :row="row" :key="row.id" />
              </tbody>
            </table>
            <span class="button-wrapper add-new-document" @click="handleAddRequiredBookKeeping(information.id)">
              <a class="button is-info">+</a> Добавить строку в таблице
            </span>
          </div>
        </div>
      </div>
      <div class="centered">
        <button class="button save-content" @click="handleSaveRequiredInformation()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BankRequirementFile from 'components/Information/BankRequirementFile'
import BankRequirementRow from 'components/Information/BankRequirementRow'
import BankRequirementBookkeeping from 'components/Information/BankRequirementBookkeeping'
import uuidv4 from 'uuid/v4'

export default {
  name: 'BankRequirementItem',
  data () {
    return {
      updateTimer: null,
      showUrl: false,
      startDate: '',
      endDate: '',
      disclosureDate: '',
      showDatesTable: true,
      disabled: false
    }
  },
  props: {
    information: {
      required: true
    }
  },
  computed: {
    category () {
      this.showDatesTable = true
      if (this.information.url.length) {
        this.showUrl = true
      }
      if (!this.information.url &&
      this.information.requiredInformationFiles.length === 0 &&
      this.information.requiredInformationRows.length !== 0) {
        this.showDatesTable = false
        return 'rows'
      } else if (!this.information.url &&
      this.information.requiredInformationRows.length === 0 &&
      this.information.requiredInformationFiles.length !== 0) {
        return 'files'
      } else if (this.information.requiredInformationRows.length === 0 &&
      this.information.requiredInformationFiles.length === 0 &&
      this.showUrl) {
        return 'url'
      } else if (this.information.requiredInformationBookkeepings.length !== 0) {
        this.showDatesTable = false
        return 'bookkeeping'
      }
      return 'none'
    }
  },
  created () {
    this.disclosureDate = this.information.disclosureDate
    this.startDate = this.information.startDate
    this.endDate = this.information.endDate
  },
  methods: {
    ...mapActions(['deleteRequiredInformation',
      'updateRequiredInformation', 'addRequiredInformationRow', 'saveRequiredInformation',
      'addRequiredInformationDocument', 'addRequiredBookKeeping']),
    handleUpdate () {
      this.updateRequiredInformation(this.information)
    },
    handleSaveRequiredInformation () {
      this.disabled = true
      this.saveRequiredInformation(this.information)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    },
    addUrl () {
      this.showUrl = true
    },
    hideUrl () {
      this.showUrl = false
      this.information.url = ''
      this.handleUpdate()
    },
    dateChanged () {
      this.information.startDate = this.startDate
      this.information.endDate = this.endDate
      this.information.disclosureDate = this.disclosureDate
      this.handleUpdate()
    },
    handleAddRequiredInformationDocument (id) {
      this.addRequiredInformationDocument({
        id: uuidv4(),
        required_information_id: id,
        file: ''
      })
    },
    handleAddRequiredInformationRow (id) {
      this.addRequiredInformationRow({
        id: uuidv4(),
        required_information_id: id
      })
    },
    handleAddRequiredBookKeeping (id) {
      this.addRequiredBookKeeping({
        id: uuidv4(),
        required_information_id: id
      })
    }
  },
  components: {
    BankRequirementFile,
    BankRequirementRow,
    BankRequirementBookkeeping
  }
}
</script>

<style scoped>
.document-container {
  background: #eee;
  padding: 35px;
  min-width: 675px;
}
.document-wrapper {
  padding: 15px;
  height: initial;
  display: block;
}
.delete-icon {
  margin: 0 20px 0 0;
  height: 28px;
  width: 28px;
  position: initial;
}
.input-data {
  width: 100%;
}
.control {
  margin: 0 0 12px;
}
.add-new-document {
  margin: 15px 0;
}
.button-group img {
  width: 24px;
  margin: 0 7px 0 0;
}
.bookkeeping {
  max-width: 950px;
}
.information-url .control {
  width: 100%;
}
.dates {
  max-width: 700px;
  margin: 0 0 17px;
}
.save-content {
  margin: 20px 0 0;
}
</style>



// WEBPACK FOOTER //
// BankRequirementItem.vue?bda6aa7e